module.exports = __webpack_public_path__ + "static/media/well.c2fcc23a.svg";